/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import { Checkbox, FormControlLabel, Switch } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { createProduct, updateProduct } from "../../actions/productActions";
import { useSnackbar } from "react-simple-snackbar";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    backgroundColor: "#1976D2",
    marginLeft: 0,
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: "white",
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const getDiscountValue = (value) =>
  Math.min(Math.max(Number(value) || 0, 0), 100);
const getFixedDiscountValue = (value) => Math.max(Number(value) || 0, 0);

const AddProduct = ({ setOpen, open, currentId, setCurrentId }) => {
  const location = useLocation();
  const [productData, setProductData] = useState({
    title: "",
    price: "",
    vat: "",
    discountEnabled: false,
    discountType: "percentage",
    discount: 0,
    fixedDiscount: 0,
    userId: "",
    quantity: 0,
    archived: false,
  });
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("profile")));

  const dispatch = useDispatch();
  const product = useSelector((state) =>
    currentId ? state.product.products.find((c) => c._id === currentId) : null
  );
  // eslint-disable-next-line
  const [openSnackbar, closeSnackbar] = useSnackbar();

  useEffect(() => {
    if (product) {
      setProductData({
        ...product,
        discountEnabled: Boolean(product.discountEnabled),
        discountType: product.discountType || "percentage",
        discount: product.discount || 0,
        fixedDiscount: product.fixedDiscount || 0,
      });
    }
  }, [product]);

  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem("profile")));
    // setClientData({...clientData, userId: user?.result?._id})
  }, [location]);

  useEffect(() => {
    var checkId = user?.result?._id;
    if (checkId !== undefined) {
      setProductData((prevState) => ({ ...prevState, userId: [checkId] }));
    } else {
      setProductData((prevState) => ({
        ...prevState,
        userId: [user?.result?.googleId],
      }));
    }
  }, [location]);

  const getProductPayload = () => {
    const discount = getDiscountValue(productData.discount);
    const fixedDiscount = getFixedDiscountValue(productData.fixedDiscount);
    const discountType =
      productData.discountType === "fixed" ? "fixed" : "percentage";
    const activeDiscountValue =
      discountType === "fixed" ? fixedDiscount : discount;
    const discountEnabled =
      Boolean(productData.discountEnabled) || activeDiscountValue > 0;
    const userId =
      productData.userId?.length > 0
        ? productData.userId
        : [user?.result?._id || user?.result?.googleId].filter(Boolean);

    return {
      ...productData,
      price: Number(productData.price) || 0,
      vat: Number(productData.vat) || 0,
      quantity: Number(productData.quantity) || 0,
      userId,
      discountEnabled,
      discountType: discountEnabled ? discountType : "percentage",
      discount: discountEnabled && discountType === "percentage" ? discount : 0,
      fixedDiscount:
        discountEnabled && discountType === "fixed" ? fixedDiscount : 0,
    };
  };

  const handleSubmitClient = (e) => {
    e.preventDefault();
    const productPayload = getProductPayload();

    if (currentId) {
      dispatch(updateProduct(currentId, productPayload, openSnackbar));
    } else {
      if (productPayload.userId?.length > 0) {
        dispatch(createProduct(productPayload, openSnackbar));
      } else {
        alert("somthing wrong");
      }
    }

    clear();
    handleClose();
  };

  const clear = () => {
    setProductData({
      title: "",
      price: 0,
      vat: 0,
      discountEnabled: false,
      discountType: "percentage",
      discount: 0,
      fixedDiscount: 0,
      quantity: 0,
      archived: false,
      userId: [],
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const inputStyle = {
    display: "block",
    padding: "1.4rem 0.75rem",
    width: "100%",
    fontSize: "0.8rem",
    lineHeight: 1.25,
    color: "#55595c",
    backgroundColor: "#fff",
    backgroundImage: "none",
    backgroundClip: "padding-box",
    borderTop: "0",
    borderRight: "0",
    borderBottom: "1px solid #eee",
    borderLeft: "0",
    borderRadius: "3px",
    transition: "all 0.25s cubic-bezier(0.4, 0, 1, 1)",
  };

  const handleSelectArchived = (event) => {
    setProductData((prevState) => ({
      ...prevState,
      archived: event.target.checked,
    }));
  };

  const handleSelectDiscount = (event, checked) => {
    setProductData((prevState) => ({
      ...prevState,
      discountEnabled: checked,
      discountType: checked ? prevState.discountType : "percentage",
      discount: checked ? prevState.discount : 0,
      fixedDiscount: checked ? prevState.fixedDiscount : 0,
    }));
  };

  const handleSelectDiscountType = (event) => {
    const discountType = event.target.value;

    setProductData((prevState) => ({
      ...prevState,
      discountType,
      discountEnabled: true,
      discount: discountType === "percentage" ? prevState.discount : 0,
      fixedDiscount:
        discountType === "fixed" ? prevState.fixedDiscount : 0,
    }));
  };

  const handleDiscountValueChange = (event) => {
    const isFixedDiscount = productData.discountType === "fixed";
    const value = event.target.value;

    setProductData((prevState) => ({
      ...prevState,
      discount: isFixedDiscount ? 0 : value,
      fixedDiscount: isFixedDiscount ? value : 0,
      discountEnabled:
        Boolean(prevState.discountEnabled) ||
        (isFixedDiscount
          ? getFixedDiscountValue(value) > 0
          : getDiscountValue(value) > 0),
    }));
  };

  const discountInputValue =
    productData.discountType === "fixed"
      ? productData.fixedDiscount
      : productData.discount;

  return (
    <div>
      <form onSubmit={handleSubmitClient}>
        <Dialog
          onClose={(e, reason) => {
            if (reason !== "backdropClick") {
              handleClose();
            }
          }}
          aria-labelledby="customized-dialog-title"
          open={open}
          fullWidth
        >
          <DialogTitle
            id="customized-dialog-title"
            onClose={handleClose}
            style={{ paddingLeft: "20px", color: "white" }}
          >
            {currentId ? "Edit Product" : "Add new Product"}
          </DialogTitle>
          <DialogContent dividers>
            <div className="customInputs">
              <input
                placeholder="Title"
                style={inputStyle}
                name="title"
                type="text"
                onChange={(e) =>
                  setProductData({ ...productData, title: e.target.value })
                }
                value={productData.title}
              />

              <input
                placeholder="Price"
                style={inputStyle}
                name="price"
                type="number"
                onChange={(e) =>
                  setProductData({ ...productData, price: e.target.value })
                }
                value={productData.price}
              />
              <input
                placeholder="Quantity"
                style={inputStyle}
                name="quantity"
                type="number"
                onChange={(e) =>
                  setProductData({ ...productData, quantity: e.target.value })
                }
                value={productData.quantity}
              />

              <input
                placeholder="VAT"
                style={inputStyle}
                name="vat"
                type="number"
                onChange={(e) =>
                  setProductData({ ...productData, vat: e.target.value })
                }
                value={productData.vat}
              />
              <div>
                <FormControlLabel
                  control={
                    <Switch
                      checked={Boolean(productData?.discountEnabled)}
                      onChange={handleSelectDiscount}
                      color="primary"
                    />
                  }
                  label="Discount"
                />
              </div>
              <select
                style={inputStyle}
                name="discountType"
                disabled={!productData?.discountEnabled}
                onChange={handleSelectDiscountType}
                value={productData.discountType || "percentage"}
              >
                <option value="percentage">Percentage (%)</option>
                <option value="fixed">Fixed value</option>
              </select>
              <input
                placeholder={
                  productData.discountType === "fixed"
                    ? "Fixed Discount"
                    : "Discount (%)"
                }
                style={inputStyle}
                name="discountValue"
                type="number"
                min="0"
                max={
                  productData.discountType === "percentage" ? "100" : undefined
                }
                disabled={!productData?.discountEnabled}
                onChange={handleDiscountValueChange}
                value={discountInputValue}
              />
              <div>
                {" "}
                <label>Archived</label>
                <Checkbox
                  checked={productData?.archived}
                  onChange={(event) => handleSelectArchived(event)}
                />
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              type="button"
              onClick={handleSubmitClient}
              variant="contained"
              style={{ marginRight: "25px" }}
            >
              Save Product
            </Button>
          </DialogActions>
        </Dialog>
      </form>
    </div>
  );
};

export default AddProduct;
